// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

ion-card {
  background: var(--ion-color-primary-darker);
}

ion-item {
  --background: white;
  --padding: 0;
  --margin: 0;
}

ion-badge {
  border-radius: 50%;
}

.article-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));
  gap: 2rem;
  margin: 10px 0;
}

.article-img {
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.article-image img {
  display: flex;
  min-width: 100%;
  width: 100px;
  height: 260px;
  border-radius: 20px 20px 0 0;
  margin: auto;
}

.article-card {
  background: white;
  border-radius: 20px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  margin: 1px auto;
  max-width: 424px;
  width: calc(100% - 30px);
}

.article-card:hover {
  box-shadow: 0 12px 28px 0 rgba(34, 68, 123, 0.22);
  transform: translateY(-4px);
  cursor: pointer;
}

.article-card:active {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px 0 rgba(34, 68, 123, 0.18);
}

.article-card .article-image img {
  transition: transform 0.4s ease;
}

.article-card:hover .article-image img {
  transform: scale(1.04);
}

.article-content {
  padding: 0.25rem 1rem 1rem 1rem;
}

.item {
  background-color: white !important;
  color: red !important;
}

.article-content .card-category {
  font-size: 0, 875rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;
  color: #6b82a7;
  display: block;
  text-decoration: none;
}

.article-content .card-title {
  color: #22447b;
  font-size: 0.875rem;
  margin: 0.5rem 0;
}

.article-content .card-excerpt {
  font-size: 0.75rem;
  line-height: 1rem;
  color: #6b82a7;
  margin: 0;
  text-align: justify;
}

.card-excerpt {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

@media screen and (min-width: 768px) {
  .site-container {
    max-width: 608px;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (min-width: 1280px) {
  .site-container {
    max-width: 1156px;
  }
}
.category {
  font-size: 0.625rem;
  padding: 0.5rem;
  margin-right: 0.5rem;
}

@media screen and (min-width: 1150px) {
  .article-container {
    grid-template-columns: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/news-item/news-item.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,YAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,uDAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;AADF;;AAIA;EACE,iDAAA;EACA,2BAAA;EACA,eAAA;AADF;;AAIA;EACE,2BAAA;EACA,gDAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,kCAAA;EACA,qBAAA;AADF;;AAIA;EACE,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AADF;;AAIA;EACE;IACE,gBAAA;IACA,qCAAA;EADF;AACF;AAIA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE,mBAAA;EACA,eAAA;EACA,oBAAA;AAHF;;AAMA;EACE;IACE,2BAAA;EAHF;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nion-card {\n  background: var(--ion-color-primary-darker);\n}\n\nion-item {\n  --background: white;\n  --padding: 0;\n  --margin: 0;\n}\n\nion-badge {\n  border-radius: 50%;\n}\n\n.article-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(265px, 1fr));\n  gap: 2rem;\n  margin: 10px 0;\n}\n\n.article-img {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n}\n\n\n.article-image img {\n  display: flex;\n  min-width: 100%;\n  width: 100px;\n  height: 260px;\n  border-radius: 20px 20px 0 0;\n  margin: auto;\n}\n\n.article-card {\n  background: white;\n  border-radius: 20px;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  margin: 1px auto;\n  max-width: 424px;\n  width: calc(100% - 30px);\n}\n\n.article-card:hover {\n  box-shadow: 0 12px 28px 0 rgba(34, 68, 123, 0.22);\n  transform: translateY(-4px);\n  cursor: pointer;\n}\n\n.article-card:active {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px 0 rgba(34, 68, 123, 0.18);\n}\n\n.article-card .article-image img {\n  transition: transform 0.4s ease;\n}\n\n.article-card:hover .article-image img {\n  transform: scale(1.04);\n}\n\n.article-content {\n  padding: 0.25rem 1rem 1rem 1rem;\n}\n\n.item {\n  background-color: white !important;\n  color: red !important;\n}\n\n.article-content .card-category {\n  font-size: 0, 875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 600;\n  color: #6b82a7;\n  display: block;\n  text-decoration: none;\n}\n\n.article-content .card-title {\n  color: #22447b;\n  font-size: 0.875rem;\n  margin: 0.5rem 0;\n}\n\n.article-content .card-excerpt {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #6b82a7;\n  margin: 0;\n  text-align: justify;\n}\n\n.card-excerpt {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n  overflow: hidden;\n}\n\n@media screen and (min-width: 768px) {\n  .site-container {\n    max-width: 608px;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (min-width: 1280px) {\n  .site-container {\n    max-width: 1156px;\n  }\n}\n\n.category {\n  font-size: 0.625rem;\n  padding: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n@media screen and (min-width: 1150px) {\n  .article-container {\n    grid-template-columns: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
